import script from "./ReportsPaymentsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsPaymentsTab.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsPaymentsTab.vue?vue&type=style&index=0&id=49d3bb14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d3bb14"]])

export default __exports__